import { render, staticRenderFns } from "./EntityContact.vue?vue&type=template&id=765e368f"
import script from "./EntityContact.vue?vue&type=script&lang=js"
export * from "./EntityContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports